import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDText,
    JDImage,
    JDTouchable
} from '@jdreact/jdreact-core-lib';
import { NavBar, utils } from '@ltfe/ltfe-core-lib';
import img from '../../common/img';
const { pt } = utils;

export default class Error extends PureComponent {
    static defaultProps = {
        codeInfo: {
            qrCodeUrl: img.error_icon
        }
    }

    render() {
        const { changeStatu } = this.props;

        return (
            <View>
                <NavBar title="京东兑换券" />
                <View style={ st.QRcode }>
                    <View style={ st.yzm }>
                        <View style={ st.img_view }>
                            <JDImage style={ st.y_img } source={ img.error_icon } />
                        </View>
                        <JDText stylt={ st.txt_m }>页面走丢了，请稍后重试。</JDText>
                        <JDTouchable onPress={ () => {
                            changeStatu(false);
                        } }>
                            <View style={ st.btn }>
                                <JDText stylt={ st.txt_y }>立即刷新</JDText>
                            </View>
                        </JDTouchable>
                    </View>
                </View>
            </View>
        );
    }
}
Error.contextTypes = {
    router: PropTypes.object
};
const st = StyleSheet.create({
    QRcode: {
        marginTop: pt(100),
        alignItems: 'center'
    },
    yzm: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: pt(207),
        height: pt(312)
    },
    txt_m: {
        textAlign: 'center',
        fontSize: pt(13),
        color: '#FF282828',
        fontWeight: 'normal'
    },
    txt_y: {
        fontSize: pt(16),
        color: 'gray',
        fontWeight: 'normal'
    },
    img_view: {
        paddingBottom: pt(23)
    },
    y_img: {
        height: pt(150),
        width: pt(150)
    },
    btn: {
        alignItems: 'center',
        justifyContent: 'center',
        width: pt(120),
        height: pt(35),
        borderRadius: pt(20),
        borderColor: 'red',
        marginTop: pt(20),
        backgroundColor: '#F5F7F8'

    }
});
